export const ICON_TYPE_MAPPING_BY_NETWORK = {
  VISA: 'visa',
  DISCOVER: 'discover',
  PULSE: 'pulse',
  MASTERCARD: 'master-card',
  MARQETA: 'marqeta-network',
};
